import { render, staticRenderFns } from "./BrandPlaceCard.vue?vue&type=template&id=19534b3a&"
import script from "./BrandPlaceCard.vue?vue&type=script&lang=js&"
export * from "./BrandPlaceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports